
/* ============================== src/api/queries/reports.js ============================== */
import { useQuery } from "@tanstack/react-query";
import { api } from "../client";

export const REPORTS_KEY = ["reports"];

export function useWorkloadReportQuery(fromIso, toIso, options = {}) {
  return useQuery({
    queryKey: [...REPORTS_KEY, "workload", fromIso, toIso],
    queryFn: () => api.get(`/reports/workload?from=${fromIso}&to=${toIso}`),
    enabled: !!fromIso && !!toIso,
    ...options,
  });
}

export function usePeriodCapacityQuery(fromIso, toIso, options = {}) {
  return useQuery({
    queryKey: [...REPORTS_KEY, "period-capacity", fromIso, toIso],
    queryFn: () =>
      api.get(`/reports/period-capacity?from=${fromIso}&to=${toIso}`),
    enabled: !!fromIso && !!toIso,
    ...options,
  });
}

export function useEmployeeTasksReportQuery(
  employeeId,
  fromIso,
  toIso,
  options = {},
) {
  return useQuery({
    queryKey: [...REPORTS_KEY, "employee-tasks", employeeId, fromIso, toIso],
    queryFn: () =>
      api.get(
        `/reports/employee-tasks?employeeId=${employeeId}&from=${fromIso}&to=${toIso}`,
      ),
    enabled: !!employeeId && !!fromIso && !!toIso,
    ...options,
  });
}

export function useWipReportQuery(projectId, fromIso, toIso, options = {}) {
  return useQuery({
    queryKey: [...REPORTS_KEY, "wip", projectId, fromIso, toIso],
    queryFn: () =>
      api.get(
        `/reports/wip?projectId=${projectId ?? ""}&from=${fromIso ?? ""}&to=${toIso ?? ""}`,
      ),
    ...options,
  });
}
